"use client";

import type { TextColor } from "@homeinstead/schemas";
import type { ReactNode } from "react";
import type { FieldValues, UseFormReturn } from "react-hook-form";

import { FormProvider } from "react-hook-form";
import { getInquiryStepClassName } from "./get-inquiry-step-class-name";
import { InquiryStepBackButton } from "./InquiryStepBackButton";

type InquiryTwoStepFormProps<TForm extends FieldValues> = {
  handleFormSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  hiddenFields?: ReactNode;
  methods: UseFormReturn<TForm, unknown, TForm>;
  onBack: () => void;
  step: 1 | 2;
  step1: ReactNode;
  step2: ReactNode;
  submitFormAction: (formData: FormData) => void;
  textColor?: TextColor;
};

function InquiryTwoStepForm<TForm extends FieldValues>({
  handleFormSubmit,
  hiddenFields,
  methods,
  onBack,
  step,
  step1,
  step2,
  submitFormAction,
  textColor,
}: InquiryTwoStepFormProps<TForm>) {
  return (
    <FormProvider {...methods}>
      <form
        action={submitFormAction}
        className="flex w-full flex-col gap-6"
        onSubmit={handleFormSubmit}
      >
        {hiddenFields}
        <div className="grid w-full overflow-hidden">
          <div className={getInquiryStepClassName(step, 1)}>{step1}</div>
          <div className={getInquiryStepClassName(step, 2)}>
            <InquiryStepBackButton onBack={onBack} textColor={textColor} />
            {step2}
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

export { InquiryTwoStepForm };
